import { CalendarDays } from "lucide-react";

export default function GoogleOriginBadge({
  meeting,
}: {
  meeting?: { calendar_origin?: string } | null;
}) {
  if (meeting?.calendar_origin !== "google") return null;

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-700">
      <CalendarDays size={11} aria-hidden="true" /> Google Agenda
    </span>
  );
}
